import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Icon } from 'app/design-system/components/Icon';
import { Tooltip } from 'app/design-system/components/Popper';
import { ICON_NAME_HELP } from 'app/design-system/constants/IconNames';
import { Trans, useTranslation } from 'app/lang';
import { getFreebets } from 'app/lib/account/actions';
import {
  hasAccountRequiredName,
  selectFreeBetsData,
  selectFreeBetsError,
  selectFreeBetsRequested,
} from 'app/lib/account/selectors';
import useComponentWillMount from 'app/lib/hooks/useComponentWillMount';
import { ROUTE_PATH } from 'app/lib/routing/constants';

import { Freebet } from './components/Freebet';

import dictionary from './Freebets.dictionary.json';

import styles from './Freebets.module.scss';

export const Freebets = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const freebets = useSelector(selectFreeBetsData);
  const isRequested = useSelector(selectFreeBetsRequested);
  const hasError = useSelector(selectFreeBetsError);
  const hasRequiredName = useSelector(hasAccountRequiredName);
  const popperRef = useRef(null);

  useComponentWillMount(() => {
    if (!isRequested) {
      dispatch(getFreebets());
    }
  });

  if (hasError) {
    return (
      <h4>{t(dictionary.errorMessage)}</h4>
    );
  }

  if (freebets && freebets.length) {
    return (
      <>
        <div className={styles.titleWrapper}>
          <h4 className={styles.title}>{t(dictionary.title)}</h4>
          <Tooltip boundary={popperRef}
                   popperClassName={styles.tooltip}
                   content={t(dictionary.tooltipContent)}>
            <Icon icon={ICON_NAME_HELP}
                  className={styles.titleIcon}
                  size={16} />
          </Tooltip>
        </div>
        {!hasRequiredName && (
          <div className={styles.noUserFullNameNotice}>
            <Trans data={dictionary.noUserFullNameNotice}
                   components={{
                     noticeChange: (
                       <Link to={ROUTE_PATH.PERSONAL} />
                     ),
                   }} />
          </div>
        )}
        <ul className={styles.list}>
          {freebets && freebets.map((freeBet) => (
            <Freebet key={freeBet.id}
                     {...freeBet} />
          ))}
        </ul>
      </>
    );
  }

  return null;
};
